
import React from 'react';
import { Loader2 } from 'lucide-react';
import { Message } from './types';

interface MessageItemProps {
  message: Message;
  isLoading?: boolean;
}

const MessageItem: React.FC<MessageItemProps> = ({ message, isLoading }) => {
  return (
    <div 
      className={`flex ${message.role === 'user' ? 'justify-end' : 'justify-start'} my-2`}
    >
      <div 
        className={`max-w-[80%] rounded-lg px-4 py-2 break-words ${
          message.role === 'user' 
            ? 'bg-glowingTeal text-white' 
            : 'bg-gray-100'
        }`}
      >
        {isLoading ? (
          <Loader2 className="h-5 w-5 animate-spin text-gray-500" />
        ) : (
          message.content
        )}
      </div>
    </div>
  );
};

export default MessageItem;
